module.exports = __webpack_public_path__ + "assets/images/UNFIT10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/UNFIT10.png
// module id = 1439
// module chunks = 1